import React from 'react';
import {
  IProductSectionContext,
  productSectionBlockName,
  ProductSectionContext,
} from '../ProductSection/ProductSection';
import ProductPrice from '@gik/ui/ProductPrice';
import { Form } from '@gik/ui';
import { CartItem, IOrderForm, productIsAffiliate } from '@gik/checkout';
import * as validator from '@gik/core/utils/validator';
import i18n from '@gik/i18n';
import { formatCurrency } from '@gik/core/utils/format';
import Decoder from '@gik/ui/Decoder';
import bemBlock from '@gik/core/utils/bemBlock';
import { ProductStructuredData } from '@gik/seo';

type ValuesType = { [_p: string]: CartItem };

export default function ProductDetails() {
  const {
    product,
    selectedCartItem,
    setSelectedCartItem,
    setHasErrors,
    showCustomError,
    setShowCustomError,
  } = React.useContext<IProductSectionContext>(ProductSectionContext);

  const validateForm = (values: IOrderForm) => {
    const errors = {};
    const itemId = 'item-0';
    const cartItem = values[itemId];

    if (cartItem) {
      if (product.type !== 'fixed' && validator.isEmpty(values[itemId])) {
        errors[itemId] = { message: i18n.t('validation.required') };
      }

      if (product.type === 'input') {
        const minValue = product.variations[0].minValue;
        const maxValue = product.variations[0].maxValue;
        const numValue = cartItem.price;
        if (validator.minValueExclusive(minValue, numValue)) {
          errors[itemId] = {
            message: i18n.t('validation.minValue', { count: formatCurrency(minValue) } as object),
          };
        } else if (validator.maxValueExclusive(maxValue, numValue)) {
          errors[itemId] = {
            message: i18n.t('validation.maxValue', { count: formatCurrency(maxValue) } as object),
          };
        }
      }
    }

    setHasErrors(Object.keys(errors).length > 0);

    return errors;
  };

  const onChange = (values: ValuesType) => {
    setShowCustomError(false);

    if (product) {
      const cartItem: CartItem = values['item-0'];
      setSelectedCartItem(cartItem);
    }
  };

  const bem = bemBlock(productSectionBlockName);

  return (
    <ProductStructuredData product={product}>
      <div className={bem('product-details')}>
        <section className={bem('title')}>
          <h1>
            <Decoder text={product.name} />
          </h1>
          {product.isTangoCardProduct && <section className={bem('tc-disclaimer')}>on Give InKind</section>}
        </section>
        <section className={bem('price')}>
          <Form
            vertical
            validate={validateForm}
            onChange={onChange}
            initialValues={{ [`item-0`]: selectedCartItem }}
            render={() => <ProductPrice product={product} showCustomError={showCustomError} />}
          />

          {!product.isTangoCardProduct && productIsAffiliate(product) && product.sources && product.sources.length && (
            <section className={bem('vendor')}>on {product.sources[0].name}</section>
          )}
        </section>
      </div>
    </ProductStructuredData>
  );
}
